interface ShareContext {
    shareableText?: string;
    title?: string;
}

interface ShareActions {
    showImportEmailModal: () => void;
    showCopyText: () => void;
}

export function createNetworkShareBehaviors() {
    return {
        twitter: (shareTarget: string, context: ShareContext) => {
            const twitterBoxWidth = 550;
            const twitterBoxHeight = 420;
            const twitterBoxLeft = window.innerWidth / 2 - twitterBoxWidth / 2;
            const twitterBoxTop = window.innerHeight / 2 - twitterBoxHeight / 2;
            const windowParams = `scrollbars=yes,resizable=yes,toolbar=no,location=yes,
            width=${twitterBoxWidth},height=${twitterBoxHeight}, left=${twitterBoxLeft},
            top=${twitterBoxTop}`;
            window.open(
                `https://x.com/intent/post?text=${encodeURIComponent(
                    context.shareableText || '',
                )}&url=${encodeURIComponent(shareTarget)}`,
                'intent',
                windowParams,
            );
        },
        mailto: (shareTarget: string, context: ShareContext) => {
            const emailBody = `${context.shareableText}\n${shareTarget}`;
            window.location.href = `mailto:?subject=${encodeURIComponent(
                context.title || '',
            )}&body=${encodeURIComponent(emailBody)}`;
        },
        mail_ref: (shareTarget: string, context: ShareContext, actions: ShareActions) => {
            actions.showImportEmailModal();
        },
        clipboard: (shareTarget: string, context: ShareContext, actions: ShareActions) => {
            actions.showCopyText();
        },
        whatsapp: (shareTarget: string, context: ShareContext) => {
            const url = `https://wa.me?text=${encodeURIComponent(
                `${context.shareableText}\n${shareTarget}`,
            )}`;
            window.open(url);
        },
    };
}
